module.exports = __webpack_public_path__ + "img/coverArt2.9a872f03.jpg";